import React from "react";
import { RATE_US_LIMIT } from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";
import getUserRateUsStore from "../../../../stores/auditor-store/user-rate-us-store";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const UserRateUsForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={RATE_US_LIMIT}
          value={getUserRateUsStore().rateUsLimit.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserRateUsStore().setRateUsLimit(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          getUserRateUsStore().getRatingsData();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});

export default UserRateUsForm;
